import axios from "@/app/Axios";

class SinCuchillos {

    async index() {
        try {
            const response = await axios.get("/sincuchillo");
            return response.data.data;
        } catch (error) {
            console.log(error);
            console.log(error.response.data);
            const errorData = error.response.data;
            return errorData;
        }
    }
    async obtenerNumeroMaximo() {
        try {
            const response = await axios.get("/obtenerNumeroMaximo"); // Asegúrate de ajustar la ruta
            if (response.data && response.data.numeroMaximo) {
                return response.data.numeroMaximo;
            }
        } catch (error) {
            console.error("Error al obtener el número máximo:", error);
        }
        return null; // Devolvemos null en caso de error
    }

}

export default SinCuchillos;
